import { Link } from 'react-router-dom';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import HubIcon from '@mui/icons-material/Hub';
import GroupsIcon from '@mui/icons-material/Groups';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ShareIcon from '@mui/icons-material/Share';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import CampaignIcon from '@mui/icons-material/Campaign';
import type { SvgIconComponent } from '@mui/icons-material';
import { MODULE_ENTRIES } from '@/config/moduleEntries';
import { BRAND } from '@/config/brand';
import { ORG_SIGN_IN_PATH, REGISTER_PATH } from '@/constants/authRoutes';
import type { ErpModule } from '@/api/platform.api';

const MODULE_ICONS: Partial<Record<ErpModule, SvgIconComponent>> = {
  POS: PointOfSaleIcon,
  CRM: HubIcon,
  HR: GroupsIcon,
  FINANCE: AccountBalanceIcon,
  PROJECTS: AssignmentIcon,
  DESK: SupportAgentIcon,
  SOCIAL: ShareIcon,
  PROCUREMENT: RequestQuoteIcon,
  LEAD_GEN: CampaignIcon,
  MARKETING: CampaignIcon,
};

export function ModuleHubPage() {
  return (
    <div>
      <div className="mb-8 text-center">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">{BRAND.name} products</h1>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
          Open the app you use day to day. Your workspace shows only the products enabled for your organization.
        </p>
        <p className="mt-3 text-sm text-slate-500 dark:text-slate-400">
          New organization?{' '}
          <Link to={REGISTER_PATH} className="font-medium text-primary-600 hover:underline dark:text-primary-400">
            Create account
          </Link>
          {' · '}
          <Link to={ORG_SIGN_IN_PATH} className="font-medium text-primary-600 hover:underline dark:text-primary-400">
            Organization sign in
          </Link>
        </p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {MODULE_ENTRIES.map((entry) => {
          const Icon = MODULE_ICONS[entry.erpModule] ?? HubIcon;
          return (
            <Link
              key={entry.slug}
              to={entry.loginPath}
              className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-4 transition hover:border-primary-400 hover:shadow-md dark:border-slate-700 dark:bg-slate-900 dark:hover:border-primary-500"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-primary-700 dark:bg-primary-950 dark:text-primary-300">
                <Icon fontSize="small" />
              </span>
              <span>
                <span className="block text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  {BRAND.name}
                </span>
                <span className="mt-0.5 block font-semibold text-slate-900 dark:text-slate-100">{entry.label}</span>
                <span className="text-xs text-slate-500 dark:text-slate-400">Sign in</span>
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
